import * as React from 'react'

interface OwnProps {
    alignment: 'left' | 'right'
    children?: React.ReactNode
}

class DropdownComponent extends React.Component<OwnProps> {
    public static defaultProps = {
        alignment: 'left',
    }

    public render() {
        return (
            <ul className={'dropdown-menu dropdown-menu-' + this.props.alignment}>
                {React.Children.map(this.props.children, (child, index) => (
                    <li key={index}>{child}</li>
                ))}
            </ul>
        )
    }
}
export default DropdownComponent
